import { ReactComponent as Logo } from "assets/images/street.svg";
import PrimaryBackButton from "components/BackButton/Primary";
import ContentContainer from "components/ContentContainer";
import LogoContainer from "components/LogoContainer";
import MaxWidthContainer from "components/MaxWidthContainer";
import SquareHighlightText from "components/SquareHighlightText";
import VideoOverlay from "components/VideoOverlay";
import { usePublicPagePopupsContext } from "iparque-components";
import React, { Suspense, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import CityAnimation from "./CityAnimation";
import { videoIds } from "./configs";
import {
  StyledHeading,
  StyledPopupsFullPageContainer,
  StyledText,
  TextContainer,
  VideoButton,
} from "./styles";

const Head: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { paddingTop, animationDuration } = usePublicPagePopupsContext();
  const [videoVisible, setVideoVisible] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const showVideo = () => setVideoVisible(true);

  const closeVideo = () => setVideoVisible(false);

  return (
    <StyledPopupsFullPageContainer
      extraPaddingTop={paddingTop}
      extraPaddingTopAnimationDuration={animationDuration}
    >
      <header>
        <MaxWidthContainer>
          <LogoContainer>
            <PrimaryBackButton color={theme.colors.street} to="/" />
            <Logo
              id="logo"
              role="img"
              aria-labelledby={t("10704") /* Logo do parquímetro inteligente */}
              title={t("10704") /* Logo do parquímetro inteligente */}
            />
          </LogoContainer>
        </MaxWidthContainer>
      </header>
      <Suspense fallback={null}>
        <CityAnimation />
      </Suspense>
      <ContentContainer>
        <TextContainer id="text">
          <StyledHeading elementType="h2" color="secondary">
            {t("10183") /* O seu quotidiano otimizado! */}
          </StyledHeading>
          <StyledText>
            <p>
              {
                t(
                  "10184"
                ) /* O iParque Street é uma solução única no mercado, idealizada para o contexto citadino que está em constante crescimento e evolução. O objetivo é apostar no planeamento urbano de forma a garantir a preservação dos recursos naturais, mas também a qualidade de vida das populações. */
              }
            </p>
            <p>
              {
                t(
                  "10185"
                ) /* Nesse sentido, introduzimos um novo conceito de parquímetro, devidamente certificado e idealizado para responder às necessidades de quem habita, trabalha ou visita os grandes centros urbanos. */
              }
            </p>
            <p>
              {
                t(
                  "10186"
                ) /* A nossa solução é, em suma, a resposta eficaz aos desafios exigentes que hoje pautam as cidades, para que o amanhã esteja garantido para as gerações futuras. */
              }
            </p>
          </StyledText>
          <SquareHighlightText
            color={theme.colors.street}
            text={
              t(
                "10187"
              ) /* iParque Street. A solução eficaz para as smart cities! */
            }
            textElementType="h1"
          />
          <VideoButton
            onClick={showVideo}
            color="info"
            className="uppercase"
            title={
              t(
                "10705"
              ) /* Caraterísticas e vantagens do parquímetro inteligente */
            }
          >
            {t("10132") /* Ver vídeo */}
          </VideoButton>
        </TextContainer>
      </ContentContainer>
      <VideoOverlay
        videoIds={videoIds}
        visible={videoVisible}
        onClose={closeVideo}
      />
    </StyledPopupsFullPageContainer>
  );
};

export default Head;
